/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ChangeChair from './ChangeChair/index'
import MissingRequiredTreatmentFields from './MissingRequiredTreatmentFields/index'
import React from 'react'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/Actions"
  
}) {
let appointmentBookingProviderCallValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'provider_call',
})
let appointmentBookingDisabledValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'disabled',
})
let aggregateData = fromHelpers.getActions(appointmentBookingProviderCallValueData, appointmentBookingDisabledValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 data="appointment_booking.provider_call"
 data="appointment_booking.disabled"
 aggregate="helpers.js getActions"
 from={aggregateData}
 paddingTop={0}
 paddingLeft={0}
 paddingBottom={0}
 paddingRight={0}
 right={0}
 height={244}
 selectedBackgroundColor="transparent"
 onClick={onClick}
/>
<ChangeChair
  viewPath={`${viewPath}/ChangeChair`}
/>
<MissingRequiredTreatmentFields
  viewPath={`${viewPath}/MissingRequiredTreatmentFields`}
/>
{children}
</React.Fragment>)
}